import React, { useEffect } from 'react';
import styled from 'styled-components'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter, Link } from "react-router-dom";
import { ApolloProvider } from '@apollo/client';
import { I18nextProvider } from "react-i18next";

import { client } from "./apollo";
import { config } from "./config";
import Navigation from './components/layout/index'
import Footer from './components/layout/Footer'
import Router from './Router'
import localization from "./localization";
import BackLayer from './components/pages/BackLayer'


function App() {

  useEffect(() => {
    // let element = document.getElementById("loadingPlatform");
    // if(element){
    //   element.style.opacity = "0";
    //   setTimeout(()=>{ 
    //     element.parentNode.removeChild(element);
    //   }, 400);
    // }
  }, [])

  return (
    <I18nextProvider i18n={localization}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ThemeProvider theme={config.theme}>
            
            <Wrapper>
              <WrapperInner>
                <Navigation />
                <Router />
                <Footer />
                <BackLayer />
              </WrapperInner>
            </Wrapper>

            <div style={{display:"none"}}>
              <Link to="/platform"></Link>
              <Link to="/learn-more-about-minimaa"></Link>
              <Link to="/home"></Link>
              <Link to="/privacy-policy"></Link>
              <Link to="/"></Link>
              <Link to="/thank-you"></Link>
              <Link to="/api-documentation"></Link>
            </div>
         
          </ThemeProvider>
        </BrowserRouter>
      </ApolloProvider>
    </I18nextProvider>
  );
}

export default App;

const Wrapper = styled.div(props => ({
  position:"relative",
}));

const WrapperInner = styled.div(props => ({
  position:"relative",
  maxWidth:1540,
  margin:"0 auto",
  minHeight:"100vh",
}));
